import { Context, createContext, useContext } from 'react';
import { IListEstimate } from '~/types/estimate';

interface IEstimateListContext {
  listIds: Array<IListEstimate['estimate_uuid']>;
  listData: Record<IListEstimate['estimate_uuid'], IListEstimate>;
  onOpenDeleteEstimateModal(estimateUuid: string): void;
  onOpenViewEstimateModal(estimateUuid: string): void;
  convertEstimateToInvoice(estimateUuid: string): void;
  onEditEstimate(estimateUuid: string): void;
  onEditListEstimate(estimateUuid: string, estimateUpdates: Partial<IListEstimate>): void;
  handleStatusChange(qsKey: string, selectedValue: string): void;
  maxListItems: number | null;
  renderFilters: boolean;
}

export const EstimateListContext: Context<IEstimateListContext> = createContext(
  {} as IEstimateListContext,
);

export function useEstimateListContext() {
  const contextData = useContext(EstimateListContext);
  return contextData;
}
